import { onPageLoaded } from './imaios-global';
import { fetch, get, pubsub } from './imaios-global';

function initialize() {
    setupEventScheme();
    startQuicklinksLazyLoad();
}

onPageLoaded(() => {
    if (window.requestIdleCallback) {
        window.requestIdleCallback(initialize);
    }
    else {
        // wait a little bit before initialize quicklinks in order
        setTimeout(function () {
            initialize();
        }, 1000);
    }
});

function setupEventScheme() {
    pubsub.subscribe(
        pubsub,
        'quicklinks-added',
        ({ selector, contentElement }) => {
            const fullSelector = `#${selector} [data-imaios-role="content"] .owl-carousel`;

            import('../imaios-theme/parts/owl.carousel.parts')
                .then(module => {
                    window.owl = module.Carousel;
                    contentElement.style.display = 'block';
                    $(fullSelector).owlCarousel({
                        items: 1,
                        navContainer: `[data-container-name=${selector}].navigation-carousel .custom-nav`,
                        margin: 10,
                        nav: true,
                        dots: false,
                        loop: true,
                        autoplay: false,
                        mouseDrag: false,
                        touchDrag: false,
                        navRewind: false
                    }).trigger('to.owl.carousel', [ 0, 0 ]);

                    const placeholderElement = document.querySelector('#' + selector + ' [data-imaios-role="placeholder"]');


                    if (placeholderElement) {
                        placeholderElement.style.display = 'none';
                        placeholderElement.innerHTML = '';
                        placeholderElement.remove();
                    }
                });

            if (selector === 'desktop') {
                const target = document.getElementById(selector);

                if (target !== null) {
                    if (ResizeObserver) {
                        new ResizeObserver(() => resizeQuickLinks(target)).observe(target);
                    }
                    else {
                        window.addEventListener('resize', () => resizeQuickLinks(target));
                    }
                }

                resizeQuickLinks(target);
            }
            document
                .querySelectorAll('.quick-links-owl-item .quick-link')
                .forEach(quicklink => {
                    quicklink.addEventListener('click', () => {
                        if (selector === 'desktop') {
                            pubsub.publish('analytics-quicklinks', {
                                currency: quicklink.getAttribute('data-analytics-param-currency'),
                                value: quicklink.getAttribute('data-analytics-param-value'),
                                product: quicklink.getAttribute('data-analytics-param-product'),
                                module: quicklink.getAttribute('data-analytics-param-module'),
                                access: quicklink.getAttribute('data-analytics-param-access')
                            });
                        }
                    });
                });
            document
                .querySelectorAll('[data-quick-link]')
                .forEach(quicklink => {
                    quicklink.addEventListener('click', () => onQuicklinkClick(quicklink));
                    quicklink.addEventListener('mouseover', () => onQuicklinkHover(quicklink));
                    quicklink.addEventListener('mouseout', onQuicklinkOut);
                });

            if (get('login-manager')) {
                get('login-manager').deleteSubscriptionsTags();
            }
        }
    );
}

function onQuicklinkClick(element) {
    document
        .querySelectorAll(`[data-panel="panel-${element.dataset.quickLink}"]`)
        .forEach(panel => {
            let owl = '.owl-carousel-custom';

            $(owl).owlCarousel().trigger('to.owl.carousel', [ panel.dataset.carouselPosition, 0 ]);
            $('.owl-prev').click(function () {
                // With optional speed parameter
                // Parameters has to be in square bracket '[]'
                $(owl).owlCarousel().trigger('to.owl.carousel', [ 0, 0 ]);
            });
        });
}

function onQuicklinkHover(element) {
    let titleToHover = document
        .querySelector(`[data-panel="panel-${element.dataset.quickLink}"]`)
        .dataset
        .title
        .toLowerCase();

    const displayedTitle = document.querySelectorAll('.slide-panel-title-preview');
    displayedTitle.forEach(title => {
        title.innerHTML = titleToHover.charAt(0).toUpperCase() + titleToHover.slice(1);
    });
}

function onQuicklinkOut() {
    document
        .querySelectorAll('.slide-panel-title-preview')
        .forEach(title => {
            title.innerHTML = title.dataset.titleNoHover;
        });
}

function doResize(targets, element, ratio, padding) {
    element.style.maxHeight = (element.clientWidth * ratio) + 'px';

    const height = (element.clientWidth * ratio - padding * 2) + 'px';
    targets.forEach(elem => {
        elem.style.maxHeight = height;
        elem.style.overflow = 'auto';
    });
}

var waitingForRAF = false;

function resizeQuickLinks(target) {
    const cardAspectRatio = 1.55;
    const cardPadding = 24;

    if (window.requestAnimationFrame) {
        if (!waitingForRAF) {
            waitingForRAF = true;
            const owlContentHeight = target.querySelector('.cardBodyCarousel');
            const targets = target.querySelectorAll('.cardBodyCarousel .quick-links-owl-item');
            window.requestAnimationFrame(() => {
                waitingForRAF = false;
                doResize(targets, owlContentHeight, cardAspectRatio, cardPadding);
            });
        }
    }
    else {
        const owlContentHeight = target.querySelector('.cardBodyCarousel');
        const targets = target.querySelectorAll('.cardBodyCarousel .quick-links-owl-item');
        doResize(targets, owlContentHeight, cardAspectRatio, cardPadding);
    }

}

function startQuicklinksLazyLoad() {
    const containers = document.querySelectorAll('[data-imaios-app-container="quicklinks"]');
    let application = get('application').replace('-', '');
    fetch(window.imaiosRouting.getFosJsRoutingUrlWithSiteaccess('get_quicklinks', { application: application }))
        .then(response => response.text())
        .then(html => {
            containers.forEach(element => {
                const contentElement = element.querySelector('[data-imaios-role="content"]');
                contentElement.innerHTML = html;
                pubsub.publish('quicklinks-added', {
                    selector: element.id,
                    contentElement
                });
            });
        });
}
